<template>
<div>
    <div class="row" style="margin-bottom: 7px;">
        <div class="col-xs-12">
            <h4>{{ $_locale('add a player without a club') }}</h4>
            <div class="row" style="margin-bottom: 7px;">
                <div class="col-xs-10 col-sm-8" style="padding-right: 7px;">
                    <label>{{ $_locale('email') }}</label>
                    <input class="form-control" 
                        v-model="email" 
                        v-bind:placeholder="$_locale('email')"
                        @keyup.enter="saveVisitorPlayer" />
                </div>
                <div class="col-xs-2 col-sm-4" style="padding-left: 7px;">
                    <label>{{ $_locale('player handicap') }}</label>
                    <input class="form-control" 
                        v-model="handicap" 
                        v-bind:placeholder="$_locale('player handicap')"
                        @keyup.enter="saveVisitorPlayer" />
                </div>
            </div>
            <div class="row">
                <div class="col-xs-6" style="padding-right: 7px;">
                    <label>{{ $_locale('first name') }}</label>
                    <input class="form-control" 
                        v-model="firstName"
                        v-bind:placeholder="$_locale('first name')"
                        @keyup.enter="saveVisitorPlayer" />
                </div>
                <div class="col-xs-6" style="padding-left: 7px;">
                    <label>{{ $_locale('last name') }}</label>
                    <input class="form-control" 
                        v-model="familyName"
                        v-bind:placeholder="$_locale('last name')"
                        @keyup.enter="saveVisitorPlayer" />
                </div>
            </div>
        </div>
    </div>
    <div class="row" v-if="showErrors">
        <div class="col-xs-12">
            <div role="alert" class="alert alert-danger">
                <p v-for="(error, index) in errors" :key="index">{{ $_locale(error.message) }}</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12">
            <button 
                class="btn btn-success btn-block" 
                @click="saveVisitorPlayer"
                :disabled="!validPlayer">
                <i class="glyphicon"
                    v-bind:class="{
                        'hidden': !processing,
                        'glyphicon-refresh': processing,
                        'spin': processing
                    }"></i>
                <span>{{ $_locale('save') }}</span>    
            </button>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

const initialData = () => ({
    processing: false,
    showErrors: false,
    errors: [],
    email: '',
    firstName: '',
    familyName: '',
    handicap: 0,
});
export default {
    data: initialData,
    computed: {
        ...mapGetters({
            adminMode: 'common/adminMode',
        }),
        validPlayer() {
            const nameExists = this.firstName.trim().length > 0 && this.familyName.trim().length > 0;
            const emailExists = this.email.trim().length > 0;
            
            return !this.processing && this.adminMode && nameExists && emailExists;
        }
    },
    methods: {
        reset() {
            const data = initialData();

            Object.keys(data).forEach((key) => {
                this[key] = data[key];
            })
        },
        saveVisitorPlayer() {
            if (!this.validPlayer) {
                this.errors = [
                    {
                        message: 'insufficient data'
                    }
                ];
                this.showErrors = true;
                return;
            }

            this.showErrors = false;
            this.errors = [];
            this.processing = true;
            
            let handicap = this.$_formatCurrency(this.handicap, false);

            if (isNaN(handicap)) {
                handicap = null;
            }

            this.$store.dispatch('golf/saveVisitorPlayer', {
                email: this.email,
                firstName: this.firstName,
                familyName: this.familyName,
                handicap,
            })
            .then(response => {
                const { data } = response;

                if (data.success) {
                    this.$emit('done', data.player);
                } else {
                    if (data.errors.length) {
                        this.showErrors = true;
                        this.errors = data.errors;
                    }
                }
                
                this.processing = false;

                return response;
            })
            .catch(() => {
                this.processing = false;
            })
        }
    } 
}
</script>